/**
 * Appends a cache-busting query param derived from the user's `updatedAt`
 * timestamp to an avatar URL.
 *
 * In production, profile pictures are stored under a stable key on R2, so the
 * `picture` URL string is identical after every re-upload even though the bytes
 * change. Without a changing `src`, the browser serves the cached old image.
 * Bumping `updatedAt` on upload lets every avatar refresh via this shared buster.
 *
 * Callers keep their own no-image fallback (initials or DEFAULT_AVATAR_URL).
 */
export const withAvatarCacheBuster = (
  picture?: string | null,
  updatedAt?: string | null
): string | null | undefined => {
  if (!picture || !updatedAt) return picture;
  return `${picture}?v=${encodeURIComponent(updatedAt)}`;
};
